import * as AntD from 'antd'
import styled from 'styled-components'
import { colours, SPACING, shadows } from '@qflow/theme'

import { FormItemContainer } from './internals'

export const FormSectionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`
export const FormSectionTitle = styled(AntD.Typography.Title).attrs(() => {
  return {
    level: 5
  }
})`
  margin: 0;
  margin-top: 1rem;
`

export const CreationDate = styled.div`
  font-size: 12px;
  font-weight: 400;
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
`

export const AddNewItem = styled.div`
  color: ${colours.TEAL};
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  margin-top: 8px;
  text-align: right;
  text-decoration: underline;
`

export interface InsetSectionProps {
  $colour: string
}
export const InsetSection = styled.div<Partial<InsetSectionProps>>`
  border: solid 1px ${colours.CLOUD_GREY};
  border-radius: 5px;

  padding: 1rem;
  margin-bottom: 1rem;

  box-shadow: 0px 1px 3px 0px #00000026;
`
const formRowStyling = `
display: flex;
flex-direction: row;
align-items: flex-end;

> * {
  margin-left: ${SPACING.FINE};
}
> *:first-child {
  margin-left: 0;
}

margin-bottom: 0.25rem;
> ${FormItemContainer} {
  margin-bottom: 0;

  display: flex;
  flex-direction: column;
  flex: 1 1 0;
}
`
export const FormRow = styled.div`
  ${formRowStyling}
  align-items: flex-end;
`
export const FormRowWithValidation = styled.div`
  ${formRowStyling}
  align-items: flex-start;
`

export const FormItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 3px;
`

export const DatePicker = styled(AntD.DatePicker)`
  width: 100%;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;

  flex: 0 0 25rem;
  height: 100%;

  padding: 0.5rem;
  padding-right: 1rem;
  padding-bottom: 2rem;
  border-right: solid lightgray 1px;
  ${shadows.LOW_NO_OFFSET}

  overflow-y: scroll;
  overflow-x: hidden;
`

export const FormList = styled(AntD.Form.List)``

export const FormSpace = styled.div`
  height: 1rem;
`
export const FormSpaceSmall = styled.div`
  height: 0.25rem;
`

export const StyledInsetSection = styled.div<Partial<InsetSectionProps>>`
  border: solid 1px ${colours.CLOUD_GREY};
  border-radius: 10px;

  padding: 0 1rem 1rem;
  margin-bottom: 1rem;
`

export const UnstyledSectionWrapper = styled.div`
  border: solid 1px ${colours.CLOUD_GREY};
  border-radius: 10px;

  padding: 0 1rem 1rem;
  margin-bottom: 1rem;
`
